export default __webpack_public_path__ + "static/media/AD.f79d5858.svg";